export interface SsoUserBadgeProps {
  authMethod: string | null | undefined;
  size?: 'sm' | 'md';
  className?: string;
}

export function SsoUserBadge({ authMethod, size = 'sm', className = '' }: SsoUserBadgeProps) {
  if (!authMethod?.startsWith('sso')) return null;

  const sizeClasses = size === 'md'
    ? 'px-2 py-0.5 text-xs'
    : 'px-1.5 py-0.5 text-xs';

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border border-accent-blue/30 bg-accent-blue/10 font-medium text-accent-blue ${sizeClasses} ${className}`}
      title="SSO-provisioned user — managed by identity provider"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        fill="currentColor"
        className="h-3 w-3 shrink-0"
        aria-hidden="true"
      >
        <path
          fillRule="evenodd"
          d="M8 1a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7ZM4.5 8A4.5 4.5 0 0 0 0 12.5V14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1.5A4.5 4.5 0 0 0 11.5 8h-7Z"
          clipRule="evenodd"
        />
      </svg>
      SSO
    </span>
  );
}
